import { Children, cloneElement } from 'react';

import LegacyBox from '../Box';

const LegacyTextList = ({
  children,
  vertical = true,
  ellipsis,
  fluid,
  font,
  size = '14px',
  intensity,
  italic,
  variant,
  affix,
  affixStyles,
  suffix,
  suffixStyles,
  verticalAlign = 'flex-start',
  justify = 'flex-start',
  itemsGutter,
  gutter = 4,
  withContentTooltip,
  itemProps = {},
  ...props
}) => {
  return (
    <LegacyBox vertical={vertical} gutter={gutter} {...props}>
      {Children.map(
        children,
        (child, index) =>
          child &&
          cloneElement(child, {
            ellipsis,
            fluid,
            font,
            size,
            intensity,
            italic,
            variant,
            affix,
            affixStyles,
            suffix,
            suffixStyles,
            verticalAlign,
            justify,
            withContentTooltip,
            gutter: itemsGutter,
            index: index,
            ...itemProps,
            ...child.props,
          })
      )}
    </LegacyBox>
  );
};

export default LegacyTextList;
